import { TempoChatListApiResponse } from "pages/tempo-chats/tempo-chat-list.typing";
import api from "./api";
import {
  Chat,
  ChatMessage,
  ChatPage,
  ChatParticipant,
  CreateTempoChatApiResponse,
  GetTempoChatUnreadCountsApiResponse,
  SubmitMessageApiResponse,
} from "@acoladgroup/tempo-messaging-library";
import { LanguageType, SUPPORTED_LANGUAGES } from "utils/language";

export const createTempoChat = async (taskId: string, language: LanguageType): Promise<Chat> => {
  const response = await api.post<CreateTempoChatApiResponse>(`/api/tempoChats`, {
    taskId,
    communicationLanguageCode: SUPPORTED_LANGUAGES[language].tempoCode,
  });
  return response.data.value;
};

export const getTempoChat = async (chatId: number, language: LanguageType): Promise<Chat> => {
  const response = await api.get<Chat>(
    `/api/tempoChats/${chatId}?communicationLanguageCode=${SUPPORTED_LANGUAGES[language].tempoCode}`
  );
  return response.data;
};

export const getChatMessagePage = async (
  chatId: number,
  pageNumber: number,
  messageToStartFrom?: number
): Promise<ChatPage> => {
  let endpointUrl = `/api/tempoChats/${chatId}/messages?page=${pageNumber}`;
  if (messageToStartFrom) {
    endpointUrl += `&startFromMessageId=${messageToStartFrom}`;
  }
  const response = await api.get<ChatPage>(endpointUrl);
  return response.data;
};

export const submitMessage = async (chatId: number, text: string): Promise<ChatMessage> => {
  const response = await api.post<SubmitMessageApiResponse>(`/api/tempoChats/${chatId}/submitMessage`, { text });
  return response.data.value;
};

export const updateLastReadMessage = async (chatId: number, lastReadMessageId: number): Promise<void> => {
  const response = await api.put<void>(`/api/tempoChats/${chatId}/updateLastRead`, { lastReadMessageId });
  return response.data;
};

export const getTempoChatUnreadCounts = async (): Promise<GetTempoChatUnreadCountsApiResponse> => {
  const response = await api.get<GetTempoChatUnreadCountsApiResponse>(`/api/tempoChats/unreadCounts`);
  return response.data;
};

export const getParticipants = async (chatId: number): Promise<ChatParticipant[]> => {
  const response = await api.get<ChatParticipant[]>(`/api/tempoChats/${chatId}/participants`);
  return response.data;
};

export const getTempoChatList = async (language: LanguageType): Promise<TempoChatListApiResponse> => {
  const response = await api.get<TempoChatListApiResponse>(
    `/api/tempoChats?translationLanguageCode=${SUPPORTED_LANGUAGES[language].tempoCode}`
  );
  return response.data;
};
